import { Link } from 'react-router-dom';

export default function AboutCta() {
  return (
    <section className="bg-secondary-950">
      <div className="w-full px-5 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-accent-400">
              Talk To Us
            </p>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black leading-tight text-background-50">
              把你的线索，交给认真对待它的人
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200 max-w-2xl">
              无论是一条还不确定的片段，还是一批可以直接支撑报道的材料，都可以通过官方通道发给我们。
              投稿不收费，也不需要你留下任何不想留下的信息。
            </p>
          </div>

          <div className="lg:col-span-5">
            <ul className="space-y-3">
              <li className="flex items-center gap-3 bg-secondary-900 border border-secondary-800 rounded-md px-4 py-3.5">
                <i className="ri-mail-lock-line text-accent-400"></i>
                <span className="text-sm text-background-100 break-all">
                  xiansuo@shentong-baoliao.com
                </span>
              </li>
              <li className="flex items-center gap-3 bg-secondary-900 border border-secondary-800 rounded-md px-4 py-3.5">
                <i className="ri-links-line text-accent-400"></i>
                <span className="text-sm text-background-100 break-all">
                  business@shentong-baoliao.com
                </span>
              </li>
            </ul>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-6 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                前往联系方式
              </Link>
              <Link
                to="/cooperation"
                className="inline-flex items-center justify-center gap-2 border border-background-50/30 hover:border-accent-400 hover:text-accent-300 text-background-50 text-sm font-medium px-6 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                商务合作
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}